import { createTheme } from '@one-thd/sui-atomic-components';

const RWBSecondaryOne = createTheme({
  palette: {
    mode: 'dark',
    background: {
      primary: 'brand'
    }
  }
});

RWBSecondaryOne.palette['--sui-palette-background-primary'] = '162 44 41';
RWBSecondaryOne.palette['--sui-palette-button-background-primary'] = '255 255 255';
RWBSecondaryOne.palette['--sui-palette-text-primary'] = '255 255 255';
RWBSecondaryOne.palette['--sui-palette-text-subtle'] = '255 255 255';

export { RWBSecondaryOne };